
import { Options, Vue } from "vue-class-component";
import { api } from "@/api";
import { getLocalProject } from "@/utils";
import { ElMessage } from "element-plus";
import { format } from "date-fns";

@Options({
  components: {},
})
export default class TestStatistics extends Vue {
  public dateRange: [string, string] | null = null;
  public statisticsData: any = null;
  public loading = false;

  public async mounted() {
    // 默认选中最近两周
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 14);
    this.dateRange = [format(start, "yyyy-MM-dd"), format(end, "yyyy-MM-dd")];
    // 进入页面后自动查询
    await this.handleSearch();
  }

  // 日期选择完成后自动查询
  public handleDateChange(val: [string, string] | null) {
    if (val && val.length === 2 && val[0] && val[1]) {
      this.handleSearch();
    }
  }

  public async handleSearch() {
    if (!this.dateRange || this.dateRange.length !== 2) {
      return;
    }
    this.loading = true;
    try {
      const project = Number(getLocalProject()) || 57;
      const token = localStorage.getItem("token") || "";
      const response = await api.getSgameChinaStatistics(
        token,
        project,
        this.dateRange[0],
        this.dateRange[1],
      );
      this.statisticsData = response.data;
    } catch (e) {
      ElMessage.error("查询失败，请稍后重试");
    } finally {
      this.loading = false;
    }
  }

  public handleExport() {
    if (!this.statisticsData) {
      ElMessage.warning("暂无可导出的数据");
      return;
    }
    const content = JSON.stringify(this.statisticsData, null, 2);
    const blob = new Blob([content], {
      type: "application/json;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const name = `测试统计_${
      this.dateRange ? this.dateRange.join("_") : ""
    }.json`;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
